var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"top"}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$moment(_vm.item).format('LL'))+" ")]),_c('a-tag',{attrs:{"color":_vm.$colors.blue}},[_c('fa-icon',{attrs:{"icon":['far','clock']}}),_vm._v(" "+_vm._s(_vm.$moment(_vm.item).format('DD/MM/YYYY'))+" ")],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }